<template>
    <v-sheet class="d-flex flex-column" style="flex: 1 0 auto">
        <v-row no-gutters align="center" class="txt" :justify="justifySpaceBetween ? 'space-between' : undefined">
            <v-col cols="12" md="auto" v-bind="$attrs.headerProps">
                <div class="w-md-140px txt--dark font-weight-medium pt-16 pb-4 px-10 px-md-20 py-md-16">{{ term }} <span v-if="required" class="secondary--text">*</span></div>
            </v-col>
            <v-col cols="12" :md="justifySpaceBetween ? 'auto' : ''" style="white-space: pre-line">
                <div class="pt-4 pb-16 px-10 px-md-20 py-md-16">
                    <slot />
                </div>
            </v-col>
        </v-row>
        <v-divider v-if="!noDevider" />
    </v-sheet>
</template>

<script>
export default {
    props: {
        term: String,
        required: Boolean,
        noDevider: Boolean,
        justifySpaceBetween: Boolean,
    },
};
</script>
